<!-- Pinned: render nothing - the admin chose the variant, the user needs no prompt and
     the title carries no information at fill time (decided 2026-07-23). -->
<div class="form-variant-selector card mb-3" *ngIf="orderedVariants.length && !soleVariantApplied && !pinned">
  <div class="card-body py-2">
    <label class="form-label small mb-1" [for]="selectorId">
      <strong>{{ label }}</strong>
    </label>
    <ng-select
        [labelForId]="selectorId"
        [items]="orderedVariants"
        bindLabel="title"
        bindValue="variantGuid"
        [searchable]="false"
        [clearable]="false"
        [closeOnSelect]="true"
        [disabled]="disabled"
        [ngModel]="selectedVariantGuid"
        (ngModelChange)="onSelectionChange($event)"
        [placeholder]="placeholder"
        [attr.aria-label]="label">
        <ng-template ng-option-tmp let-item="item">
          <div>
            <strong>{{ item.title }}</strong>
            <div class="text-muted small" *ngIf="item.description">{{ item.description }}</div>
          </div>
        </ng-template>
      </ng-select>
      <small class="text-muted" *ngIf="!selectedVariantGuid">
        Pick {{ articleFor(label) }} {{ label.toLowerCase() }} to load the relevant fields.
      </small>
  </div>
</div>
